// extracted by mini-css-extract-plugin
module.exports = {"message":"MintForm_message__2Ylbl","link":"MintForm_link__1u7_x","ratio":"MintForm_ratio__24q6H","group":"MintForm_group__pOGqj","load":"MintForm_load__25ybM"};